/**
 * @global settings Settings passed by WordPress
 * @global attributes Shortcode attributes
 */
class Perspectives {
  constructor() {
    this.controls = {
      forward: $('.video-forward'),
      rewind: $('.video-rewind'),
    };

    this.intro = $('.lot-selector .video-intro');
    this.videos = Perspectives.getVideos();
    this.areas = $('.lot-selector-area');
    this.perspectiveLabel = $('.current-perspective-label');
    this.perspectiveIndicatorImage = $('.lot-selector-perspective-indicator-image svg');
    this.current = this.videos[0]; // eslint-disable-line prefer-destructuring
    
    if (attributes.perspective) {
      this.current = this.videos.find(video => video.label === attributes.perspective);
    }
  }

  /**
   * Show correct perspective if the current one doesn't have a video
   * 1. Check if current perspective has a video
   * 2. Show the previous perspective (but don't change the current perspective!)
   * 3. Show the previous perspective reverse video, hide the forward one
   */
  init() {
    if (!this.videos.length) {
      return;
    }

    this.preloadVideos();

    if (this.intro.length) {
      this.intro[0].addEventListener('ended', () => {
        this.intro.hide(2000);
      });
    }

    if (this.isLastPerspective()) {
      let resetIndex = 0;
      if (settings.plan_video_loop && JSON.parse(settings.plan_video_loop)) {
        resetIndex = this.videos.length - 1;
      }
      
      const prevIndex = (this.current.index - 1 >= 0) ? this.current.index - 1 : resetIndex;
      const prevPerspective = this.videos[prevIndex];

      Perspectives.showPerspective(prevPerspective).then(() => {
        prevPerspective.forward.hide();
        prevPerspective.backward.show();
      });
    } else {
      Perspectives.showPerspective(this.current);
    }

    
    /**
     * Hide areas that shouldn't be visible yet
     */
    this.hideAreas();

    /**
     * Updates view to show all necessary current information
     */
    this.updateView();

    /**
     * Play forward control
     * 
     * @listens click
     */
    this.controls.forward.on('click', () => {
      this.hideAreas();
      this.toggleControlVisibility();

      this.playNext().then(() => this.updateView());
    });

    /**
     * Rewind control
     * 
     * @listens click
     */
    this.controls.rewind.on('click', () => {
      this.hideAreas();
      this.toggleControlVisibility();

      this.playPrevious().then(() => this.updateView());
    });
  }
  
  /**
   * Get all video perspectives
   * 
   * @returns {array} videos
   */
  static getVideos() {
    const perspectives = $('.lot-selector-video-perspective');
    const videos = [];

    perspectives.each((index, perspective) => {
      const label = $(perspective).data('perspective');
      const slug = $(perspective).data('slug');

      videos.push({
        index,
        label,
        slug,
        forward: $('.video-perspective-forward', perspective),
        backward: $('.video-perspective-backward', perspective),
      });
    });

    return videos;
  }

  /**
   * Play the next video in the video queue
   */
  playNext() {
    // Set the next video. Loop to the first if at the end of videos.
    /* eslint-disable max-len */
    const resetIndex = (settings.plan_video_loop && JSON.parse(settings.plan_video_loop)) ? 0 : this.videos.length - 1;
    const nextIndex = (this.current.index + 1 < this.videos.length) ? this.current.index + 1 : resetIndex;
    const nextPerspective = this.videos[nextIndex];
    /* eslint-enable max-len */

    // Reset the to be played perspective
    // Perspectives.resetPerspective(this.current);
    // Perspectives.resetPerspective(nextPerspective);

    /**
     * Show the forwards video
     * Start playing it
     */
    this.current.forward.show();
    this.current.backward.hide();
    this.current.forward[0].play();
    $('.lot-selector-video-perspectives').addClass('playing');
    
    /**
     * Reset the current perspective
     * Show the next perspective (don't play it yet)
     */
    return new Promise((resolve) => {
      const self = this;

      this.current.forward[0].addEventListener('ended', function handleEndOfVideo() {
        // Resolve the next perspective
        if (!self.isLastPerspective(nextPerspective)) {
          Perspectives.showPerspective(nextPerspective).then(() => {
            Perspectives.hidePerspective(self.current);
            Perspectives.resetPerspective(self.current);
            
            self.current.forward[0].removeEventListener('ended', handleEndOfVideo);
            
            $('.lot-selector-video-perspectives').removeClass('playing');

            self.setCurrent(nextPerspective);
            resolve(self.current);
          });
        }
      });
    });
  }

  /**
   * Play the previous video in the video queue
   */
  playPrevious() {
    /* eslint-disable max-len */
    const resetIndex = (settings.plan_video_loop && JSON.parse(settings.plan_video_loop)) ? this.videos.length - 1 : 0;
    const prevIndex = (this.current.index - 1 >= 0) ? this.current.index - 1 : resetIndex;
    const prevPerspective = this.videos[prevIndex];
    /* eslint-enable max-len */

    // Reset the to be played perspective
    if (!this.isLastPerspective()) {
      Perspectives.resetPerspective(this.current);
    }

    Perspectives.resetPerspective(prevPerspective);

    /**
     * Reset the current perspective
     * Show the previous perspective but don't play it yet
     */
    if (!this.isLastPerspective()) {
      Perspectives.showPerspective(prevPerspective).then(() => {
        Perspectives.hidePerspective(this.current);
      });
    }

    /**
     * Play the previous perspective' backwards video
     */
    prevPerspective.backward.show();
    prevPerspective.forward.hide();
    prevPerspective.backward[0].play();
    $('.lot-selector-video-perspectives').addClass('playing');
    
    return new Promise((resolve) => {
      prevPerspective.backward[0].addEventListener('ended', () => {
        $('.lot-selector-video-perspectives').removeClass('playing');

        // This should be in @setCurrent, but doesn't work for some reason
        prevPerspective.forward.show().promise().done(() => {
          setTimeout(() => {
            prevPerspective.backward.hide();
          }, 350);
        });

        this.current = prevPerspective;
        
        resolve(this.current);
      });
    });
  }

  /**
   * Set the current perspective
   * 
   * @param {object} perspective 
   */
  setCurrent(perspective) {
    // Reset perspective videos and show forwards video
    perspective.backward.hide();
    perspective.forward.show();

    Perspectives.resetPerspective(perspective);

    this.current = perspective;

    return this.current;
  }

  /**
   * Hide passed perspective video
   * 
   * @param {object} perspective 
   */
  static hidePerspective(perspective) {
    perspective.forward.parents('.lot-selector-video-perspective').hide();
  }

  /**
   * Show passed video
   * 
   * @param {object} perspective 
   */
  static showPerspective(perspective) {
    return new Promise((resolve) => {
      perspective.forward.parents('.lot-selector-video-perspective').show().promise().done(() => {
        setTimeout(() => {
          resolve();
        }, 350);
      });
    });
  }

  /**
   * Sets both videos in the passed perspective
   * to their starting positions (frame 1)
   * 
   * Best used when starting to play a perspective to make sure
   * that the needed perspective is ready.
   * 
   * @param {object} perspective 
   */
  static resetPerspective(perspective) {
    /* eslint-disable no-param-reassign */
    if (perspective.forward[0]) {
      perspective.forward[0].pause();
      perspective.forward[0].currentTime = 0;
    }

    if (perspective.backward[0]) {
      perspective.backward[0].pause();
      perspective.backward[0].currentTime = 0;
    }
    /* eslint-enable no-param-reassign */
  }

  hideAreas() {
    this.areas.hide();
  }

  showVisibleAreas() {
    const visibleAreas = this.areas.filter((index, element) => (
      JSON.parse(element.dataset.coordinates)[this.current.slug]
    ));

    this.positionAreas(visibleAreas);

    visibleAreas.show();
  }

  positionAreas(areas) {
    areas.each((index, element) => {
      const area = element;
      const coordinates = JSON.parse(element.dataset.coordinates)[this.current.slug];

      if (area.nodeName && area.nodeName.toLowerCase() === 'polygon') {
        area.setAttribute('points', coordinates);
      } else {
        area.style.left = coordinates.left;
        area.style.top = coordinates.top;
      }
    });
  }

  /**
   * Don't show the previous/next control when at the limit of perspectives
   * Only executed when ```settings.plan_video_loop``` is set to false
   */
  toggleControlVisibility() {
    if (settings.plan_video_loop && JSON.parse(settings.plan_video_loop)) {
      return;
    }

    this.controls.forward.toggleClass('control-hidden', this.current.index + 1 === this.videos.length);
    this.controls.rewind.toggleClass('control-hidden', this.current.index === 0);
  }

  updatePerspectiveIndicator() {
    if (!settings.show_perspective_indicator || !JSON.parse(settings.show_perspective_indicator)) {
      // Let the user know what they are looking at
      this.perspectiveLabel.text(this.current.label);
    }

    if (this.perspectiveIndicatorImage.length) {
      $('.current-perspective', this.perspectiveIndicatorImage).removeClass('current-perspective');
      $(`[data-perspective="${this.current.slug}"]`, this.perspectiveIndicatorImage).addClass('current-perspective');
    }
  }

  updateView() {
    this.showVisibleAreas();
    this.toggleControlVisibility();
    this.updatePerspectiveIndicator();
  }

  /**
   * Check to see if the current perspective is the last in the list
   */
  isLastPerspective(perspective = this.current) {
    // Selector loops videos, there is no 'last'
    // therefore we return false
    if (settings.plan_video_loop && JSON.parse(settings.plan_video_loop)) {
      return false;
    }

    return perspective.index === this.videos.length - 1;
  }

  preloadVideos() {
    this.videos.forEach((video) => {
      if ($(window).width() > 768) {
        video.forward[0].setAttribute('preload', '');
        video.backward[0].setAttribute('preload', '');
      }
    });

    if (this.intro.length) {
      if ($(window).width() > 768) {
        this.intro[0].setAttribute('preload', '');
        this.intro[0].setAttribute('autoplay', '');
      }
    }
  }
}
$(() => {
  if ($(window).width() > 768) {
    new Perspectives().init();
  }
});
